import { render, staticRenderFns } from "./CornerButtons.vue?vue&type=template&id=e12869f2&"
import script from "./CornerButtons.vue?vue&type=script&lang=js&"
export * from "./CornerButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports